module.exports = __webpack_public_path__ + "static/media/peacock-logo.f4e73c8a.png";